import { useTranslate } from "@refinedev/core";
import type { AddonActivation } from "types/";
import type { AddonStat } from "../AddonPanelHeader";
import { avgSecondsPerOpen } from "../utils/metrics";

const T_PREFIX = "media.projects.analytics.addons";

/** The coverage and average time stat cards shown after the funnel. */
export const useCoverageAndTimeStats = (activation: AddonActivation): AddonStat[] => {
  const t = useTranslate();
  return [
    {
      key: "coverage",
      label: t(`${T_PREFIX}.stat.coverage`),
      // Unknown coverage renders as a dash, never 0%.
      metric:
        activation.avg_session_coverage == null
          ? null
          : activation.avg_session_coverage * 100,
      type: "percentage",
      subtitle: t(`${T_PREFIX}.stat.coverageHint`),
    },
    {
      key: "avgTime",
      label: t(`${T_PREFIX}.stat.avgTime`),
      metric: avgSecondsPerOpen(activation),
      type: "minutes",
      subtitle: t(`${T_PREFIX}.stat.avgTimeHint`),
    },
  ];
};
